/* eslint-disable camelcase */
import { useMutation } from '@tanstack/react-query'
import { ReactQueryKeys, ResourcePermission } from '@/types'
import { useContext } from 'react'
import { AxiosContext } from '@/context/Axios'
import useAppStore from '@/store/useAppStore'

export const useGetPermissionsProfile = (userID: string) => {
  const axios = useContext(AxiosContext)
  const { setMyPermission } = useAppStore()
  return useMutation({
    mutationKey: [ReactQueryKeys.GET_PERMISSIONS_PROFILE, userID],
    mutationFn: async (): Promise<ResourcePermission> => {
      const response = await axios.api.post('ajax/permissions', {
        requestType: 'resourcePermLoad',
        resourceType: 4,
        uresourceID: userID,
        resourceID: userID,
        format: 'json',
      })
      if (response.data?.isError) {
        throw new Error(response.data?.errorMessage || 'Failed to load permissions')
      }
      setMyPermission(response.data.permission)
      return response.data.permission
    },
  })
}
